module.exports = __webpack_public_path__ + "assets/img/monitor-add-banner.9b89ea13.png";